import { render, staticRenderFns } from "./line.vue?vue&type=template&id=0feddd8c&scoped=true"
import script from "./line.vue?vue&type=script&lang=js"
export * from "./line.vue?vue&type=script&lang=js"
import style0 from "./line.vue?vue&type=style&index=0&id=0feddd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feddd8c",
  null
  
)

export default component.exports